import ProfileInfo from "../../../components/profile/ProfileInfo";
import { Container } from "./ProfileStyles";

const Profile = () => {
  return (
    <Container>
      <ProfileInfo />
    </Container>
  );
};

export default Profile;
